import React from 'react'
import useMedia from 'use-media'
import {
	Wrapper,
	ContainerAzul,
	ContainerElementos,
	TextoPequeno,
	ContainerRedesSociaisFooter,
	SpacerEntreBlocos,
	ImgFooterDog,
	ImgGooglePlay,
	ImgAppStore,
	ContainerUmaMarcaFooter,
	ContainerDireitosFooter,
	ImgSimplifique,
	ImgSelo,
	ContainerMobileStores,
	TextoLegalInfo,
	Row,
	Column
} from './styles'

import CustomLink from '../CustomLink'
import { InnerContainer } from '../../layouts/Default'
import { BlocoMedia } from '../Footer/styles'
import { eventTrack } from 'src/components/GoogleTagManager'

export default () => {
	const isMobile = useMedia({ maxWidth: 767 })
	return (
		<Wrapper>
			<ContainerAzul>
				<InnerContainer noOverflow={true}>
					<ContainerElementos>
						<ImgFooterDog
							src="/unidasseminovos/assets/footer/V.png"
							alt="Imagem de um V"
						/>
						{isMobile ? (
							<BlocoMedia>
								<TextoPequeno>Baixe o app</TextoPequeno>

								<ContainerMobileStores>
									<CustomLink
										to="https://play.google.com/store/apps/details?id=br.com.veloe.mobile"
										tagLabel="googleplay"
										img
										onClick={() => {
											eventTrack(
												'veloe:institucional',
												'clique:footer',
												'googleplay'
											);
										}}
									>
										<ImgGooglePlay
											src="/unidasseminovos/assets/footer/google-play.png"
											alt="Google Play Logo"
										/>
									</CustomLink>
									<CustomLink
										to="https://itunes.apple.com/us/app/veloe/id1278343398"
										tagLabel="appstore"
										img
										onClick={() => {
											eventTrack(
												'veloe:institucional',
												'clique:footer',
												'appstore'
											);
										}}
									>
										<ImgAppStore
											src="/unidasseminovos/assets/footer/app-store.png"
											alt="App Store Logo"
										/>
									</CustomLink>
								</ContainerMobileStores>

								<SpacerEntreBlocos />

								<ContainerUmaMarcaFooter>
									<TextoPequeno>Uma marca</TextoPequeno>

									<ImgSimplifique
										src="/unidasseminovos/assets/footer/logo_alelo.png"
										alt="Alelo Logo"
										style={{ marginRight: '7px' }}
									/>

									<TextoPequeno>Empresa do</TextoPequeno>

									<ImgSimplifique
										src="/unidasseminovos/assets/footer/Bradesco_V_White_RGB.png"
										alt="Bradesco logo vertical"
										style={{ marginRight: '5px', maxHeight: '50px' }}
									/>
								</ContainerUmaMarcaFooter>

								<SpacerEntreBlocos />

								<TextoPequeno>Redes Sociais</TextoPequeno>
								<ContainerRedesSociaisFooter>
									<CustomLink
										to="https://www.instagram.com/veloebr/"
										tagLabel="instagram"
										img
										center
										onClick={() => {
											eventTrack(
												'veloe:institucional',
												'clique:footer',
												'instagram'
											);
										}}
									>
										<ImgSimplifique
											src="/unidasseminovos/assets/footer/social_media_instagram.png"
											alt="Instagram Logo"
										/>
									</CustomLink>
									<CustomLink
										to="https://www.facebook.com/Veloebr/"
										tagLabel="facebook"
										img
										center
										onClick={() => {
											eventTrack(
												'veloe:institucional',
												'clique:footer',
												'facebook'
											);
										}}
									>
										<ImgSimplifique
											src="/unidasseminovos/assets/footer/social_media_facebook.png"
											alt="Facebook Logo"
										/>
									</CustomLink>
									<CustomLink
										to="https://www.youtube.com/c/Veloe"
										tagLabel="youtube"
										img
										center
										onClick={() => {
											eventTrack(
												'veloe:institucional',
												'clique:footer',
												'youtube'
											);
										}}
									>
										<ImgSimplifique
											src="/unidasseminovos/assets/footer/social_media_youtube.png"
											alt="Youtube Logo"
										/>
									</CustomLink>
									<CustomLink
										to="https://twitter.com/veloebr"
										tagLabel="twitter"
										img
										center
										onClick={() => {
											eventTrack(
												'veloe:institucional',
												'clique:footer',
												'twitter'
											);
										}}
									>
										<ImgSimplifique
											src="/unidasseminovos/assets/footer/social_media_twitter.png"
											alt="Twitter Logo"
										/>
									</CustomLink>
									<CustomLink
										to="https://open.spotify.com/user/pjad7ksh9sgzgwv78gocc647r"
										tagLabel="spotify"
										img
										center
										onClick={() => {
											eventTrack(
												'veloe:institucional',
												'clique:footer',
												'spotify'
											);
										}}
									>
										<ImgSimplifique
											src="/unidasseminovos/assets/footer/social_media_spotify.png"
											alt="Spotify Logo"
										/>
									</CustomLink>
								</ContainerRedesSociaisFooter>

								<SpacerEntreBlocos />

								<ContainerDireitosFooter>
									<ImgSelo
										src="/unidasseminovos/assets/footer/selo.png"
										alt="Selo Reclame Aqui"
									/>
									<div>
										<TextoLegalInfo>
											Alelo S.A <br />
											Alameda Xingu, Barueri - SP. 06455-030
										</TextoLegalInfo>
										<br />
										<TextoLegalInfo>
											© Todos os direitos reservados - Veloe 2020 - <br /> CNPJ: 04.740.876/0001-25
										</TextoLegalInfo>
										<div style={{ marginTop: 10 }}>
											<CustomLink
												to="/termos-de-uso"
												tagLabel="termos-de-uso-e-politica-de-privacidade"
												onClick={() => {
													eventTrack(
														'veloe:institucional',
														'clique:footer',
														'termos-de-uso'
													);
												}}
											>
												Termos de Uso e Política de Privacidade
											</CustomLink>
										</div>
									</div>
								</ContainerDireitosFooter>
							</BlocoMedia>
						) : (
							<Row>
								<Column>
									<TextoPequeno>Baixe o app</TextoPequeno>
									<ContainerMobileStores>
										<CustomLink
											to="https://play.google.com/store/apps/details?id=br.com.veloe.mobile"
											tagLabel="googleplay"
											img
											onClick={() => {
												eventTrack(
													'veloe:institucional',
													'clique:footer',
													'googleplay'
												);
											}}
										>
											<ImgGooglePlay
												src="/unidasseminovos/assets/footer/google-play.png"
												alt="Google Play Logo"
											/>
										</CustomLink>
										<CustomLink
											to="https://itunes.apple.com/us/app/veloe/id1278343398"
											tagLabel="appstore"
											img
											onClick={() => {
												eventTrack(
													'veloe:institucional',
													'clique:footer',
													'appstore'
												);
											}}
										>
											<ImgAppStore
												src="/unidasseminovos/assets/footer/app-store.png"
												alt="App Store Logo"
											/>
										</CustomLink>
									</ContainerMobileStores>

									<TextoPequeno>Redes Sociais</TextoPequeno>
									<ContainerRedesSociaisFooter>
										<CustomLink
											to="https://www.instagram.com/veloebr/"
											tagLabel="instagram"
											img
											center
											onClick={() => {
												eventTrack(
													'veloe:institucional',
													'clique:footer',
													'instagram'
												);
											}}
										>
											<ImgSimplifique
												src="/unidasseminovos/assets/footer/social_media_instagram.png"
												alt="Instagram Logo"
											/>
										</CustomLink>
										<CustomLink
											to="https://www.facebook.com/Veloebr/"
											tagLabel="facebook"
											img
											center
											onClick={() => {
												eventTrack(
													'veloe:institucional',
													'clique:footer',
													'facebook'
												);
											}}
										>
											<ImgSimplifique
												src="/unidasseminovos/assets/footer/social_media_facebook.png"
												alt="Facebook Logo"
											/>
										</CustomLink>
										<CustomLink
											to="https://www.youtube.com/c/Veloe"
											tagLabel="youtube"
											img
											center
											onClick={() => {
												eventTrack(
													'veloe:institucional',
													'clique:footer',
													'youtube'
												);
											}}
										>
											<ImgSimplifique
												src="/unidasseminovos/assets/footer/social_media_youtube.png"
												alt="Youtube Logo"
											/>
										</CustomLink>
										<CustomLink
											to="https://twitter.com/veloebr"
											tagLabel="twitter"
											img
											center
											onClick={() => {
												eventTrack(
													'veloe:institucional',
													'clique:footer',
													'twitter'
												);
											}}
										>
											<ImgSimplifique
												src="/unidasseminovos/assets/footer/social_media_twitter.png"
												alt="Twitter Logo"
											/>
										</CustomLink>
										<CustomLink
											to="https://open.spotify.com/user/pjad7ksh9sgzgwv78gocc647r"
											tagLabel="spotify"
											img
											center
											onClick={() => {
												eventTrack(
													'veloe:institucional',
													'clique:footer',
													'spotify'
												);
											}}
										>
											<ImgSimplifique
												src="/unidasseminovos/assets/footer/social_media_spotify.png"
												alt="Spotify Logo"
											/>
										</CustomLink>
									</ContainerRedesSociaisFooter>
								</Column>
								<Column>
									<ContainerUmaMarcaFooter>
										<TextoPequeno>Uma marca</TextoPequeno>

										<ImgSimplifique
											src="/unidasseminovos/assets/footer/logo_alelo.png"
											alt="Alelo Logo"
											style={{ marginRight: '7px' }}
										/>

										<TextoPequeno>Empresa do</TextoPequeno>

										<ImgSimplifique
											src="/unidasseminovos/assets/footer/Bradesco_V_White_RGB.png"
											alt="Bradesco logo vertical"
											style={{ marginRight: '5px', maxHeight: '50px' }}
										/>

									</ContainerUmaMarcaFooter>

									<ContainerDireitosFooter>
										<ImgSelo
											src="/unidasseminovos/assets/footer/selo.png"
											alt="Selo Reclame Aqui"
										/>
										<div>
											<TextoLegalInfo>
												Alelo S.A <br />
												Alameda Xingu, Barueri - SP. 06455-030
											</TextoLegalInfo>
											<br />
											<TextoLegalInfo>
												© Todos os direitos reservados - Veloe 2023 - <br /> CNPJ: 04.740.876/0001-25
											</TextoLegalInfo>
											<br />
											<CustomLink
												to="/termos-de-uso"
												tagLabel="contrato-veloe-e-politica-de-privacidade"
												onClick={() => {
													eventTrack(
														'veloe:institucional',
														'clique:footer',
														'termos-de-uso'
													);
												}}
											>
												Contrato Veloe e Política de Privacidade
											</CustomLink>
										</div>
									</ContainerDireitosFooter>
								</Column>
							</Row>
						)}
					</ContainerElementos>
				</InnerContainer>
			</ContainerAzul>
		</Wrapper>
	)
}
